module.exports = __webpack_public_path__ + "static/vedalken-female-gateway-sneak-c0dc45d9f20c2c6a4304ccb625bd05f7.jpg";